<template>
  <div class="wrapper">
    <div class="desktop-nav">
      <div class="nav-container">
        <div class="logo">
          <router-link to="/brand/main">
            <img src="~@/assets/img/logo/Logo.svg" alt="" />
          </router-link>
        </div>
        <div class="quick-search">
          <RetailerQuickSearch
            ref="retailerQuickSearch"
            key="1"
            :is-retailer="false"
            :is-brand-expired="isBrandExpired"
          />
        </div>
        <ul class="menu-items">
          <li>
            <router-link :to="'/brand/main'">
              <a-icon class="retailer-icon-style" type="home" />
              {{ $t("Components.Brands.Header.home") }}
            </router-link>
          </li>
          <!--          <li>-->
          <!--            <a href="#">-->
          <!--              <img class="inventory" src="~@/assets/img/retailer-brand-profile/inventory.svg" alt=""/>-->
          <!--              {{$t('Components.Brands.Header.inventory')}}-->
          <!--            </a>-->
          <!--          </li>-->
          <li>
            <router-link :to="'/brand/products'">
              <!-- <a-icon class="retailer-icon-style" type="audit" />
              {{ $t("Components.Brands.Header.catalog") }} -->
              <div class="svg-menu-icon">
                <svg
                  width="49"
                  height="24"
                  viewBox="0 0 49 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.5 22H29.5C30.0304 22 30.5391 21.7893 30.9142 21.4142C31.2893 21.0391 31.5 20.5304 31.5 20V4C31.5 3.46957 31.2893 2.96086 30.9142 2.58579C30.5391 2.21071 30.0304 2 29.5 2H17.5C16.9696 2 16.4609 2.21071 16.0858 2.58579C15.7107 2.96086 15.5 3.46957 15.5 4V20C15.5 20.5304 15.2893 21.0391 14.9142 21.4142C14.5391 21.7893 14.0304 22 13.5 22ZM13.5 22C12.9696 22 12.4609 21.7893 12.0858 21.4142C11.7107 21.0391 11.5 20.5304 11.5 20V11C11.5 9.9 12.4 9 13.5 9H15.5"
                    stroke="#202020"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M27.5 14H19.5"
                    stroke="#202020"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M24.5 18H19.5"
                    stroke="#202020"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M19.5 6H27.5V10H19.5V6Z"
                    stroke="#202020"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>{{ $t("Components.Brands.Header.catalog") }}</span>
              </div>
            </router-link>
          </li>
          <li>
            <router-link
              :to="
                '/brand/orders?status=pending,confirmed&_limit=50&_index=1&_order-by=PREVIOUS&_sort-by=created_at&tabId=1'
              "
            >
              <a-icon class="retailer-icon-style" type="line-chart" />
              {{ $t("Components.Brands.Header.orders") }}
            </router-link>
          </li>
          <li>
            <router-link :to="'/brand/search?id=0&channel-type='">
              <!-- <img
                id="retailerHeaderIcon"
                class="retailer-icon-style retailer-header-style"
                alt=""
              />
              Retailer -->
              <div class="svg-menu-icon">
                <svg
                  width="50"
                  height="24"
                  viewBox="0 0 50 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18 2L15 6V20C15 20.5304 15.2107 21.0391 15.5858 21.4142C15.9609 21.7893 16.4696 22 17 22H31C31.5304 22 32.0391 21.7893 32.4142 21.4142C32.7893 21.0391 33 20.5304 33 20V6L30 2H18Z"
                    stroke="#202020"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M15 6H33"
                    stroke="#202020"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M28 10C28 11.0609 27.5786 12.0783 26.8284 12.8284C26.0783 13.5786 25.0609 14 24 14C22.9391 14 21.9217 13.5786 21.1716 12.8284C20.4214 12.0783 20 11.0609 20 10"
                    stroke="#202020"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>Retailer</span>
              </div>
            </router-link>
          </li>
          <li>
            <router-link :to="'/brand/inventory'">
              <a-icon class="retailer-icon-style" type="table" />
              {{ $t("Components.Brands.Header.inventory") }}
            </router-link>
          </li>
          <li>
            <router-link :to="'/brand/training?main=true&tab=product'">
              <!-- <a-icon class="retailer-icon-style" type="bulb" /> -->
              <div class="svg-menu-icon fill">
                <svg
                  width="70"
                  height="24"
                  viewBox="0 0 70 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M36.5 24C43.1274 24 48.5 18.6274 48.5 12C48.5 5.37258 43.1274 0 36.5 0C32.9119 0 29.6916 1.57479 27.4926 4.07092C27.7362 4.07861 28.0079 4.0863 28.308 4.094C28.88 4.10866 29.452 4.116 30.024 4.116C30.7427 4.116 31.4247 4.10866 32.07 4.094C32.7153 4.07933 33.17 4.072 33.434 4.072C35.1647 4.072 36.4553 4.39466 37.306 5.04C38.1713 5.68533 38.604 6.514 38.604 7.526C38.604 8.03933 38.4647 8.55266 38.186 9.066C37.922 9.57933 37.4893 10.0413 36.888 10.452C36.3013 10.8627 35.5313 11.1707 34.578 11.376V11.42C35.8687 11.5373 36.888 11.8013 37.636 12.212C38.3987 12.608 38.9413 13.0847 39.264 13.642C39.5867 14.1847 39.748 14.7567 39.748 15.358C39.748 16.2527 39.5133 17.0227 39.044 17.668C38.5893 18.2987 37.9293 18.7827 37.064 19.12C36.1987 19.4573 35.1573 19.626 33.94 19.626C33.6173 19.626 33.126 19.6187 32.466 19.604C31.806 19.5747 31.0067 19.56 30.068 19.56C29.4667 19.56 28.88 19.5673 28.308 19.582C27.8896 19.582 27.5261 19.5898 27.2175 19.6055C29.4183 22.2884 32.7592 24 36.5 24ZM26.9 19.2012V19.186C27.384 19.1567 27.7433 19.098 27.978 19.01C28.2273 18.922 28.3887 18.746 28.462 18.482C28.55 18.218 28.594 17.822 28.594 17.294V6.382C28.594 5.83933 28.55 5.44333 28.462 5.194C28.3887 4.93 28.2273 4.754 27.978 4.666C27.7824 4.58041 27.5001 4.5254 27.1312 4.50097C25.4848 6.55522 24.5 9.16261 24.5 12C24.5 14.702 25.393 17.1954 26.9 19.2012ZM31.872 4.864C32.0627 4.61466 32.4587 4.49 33.06 4.49C33.94 4.49 34.5707 4.76866 34.952 5.326C35.3333 5.86866 35.524 6.68266 35.524 7.768C35.524 8.39866 35.4507 8.99266 35.304 9.55C35.1573 10.0927 34.8787 10.5327 34.468 10.87C34.0573 11.1927 33.478 11.354 32.73 11.354H31.608V6.382C31.608 5.61933 31.696 5.11333 31.872 4.864ZM31.608 11.728V17.294C31.608 17.8073 31.652 18.196 31.74 18.46C31.828 18.724 31.982 18.9 32.202 18.988C32.422 19.076 32.7447 19.12 33.17 19.12C34.3727 19.12 35.238 18.79 35.766 18.13C36.3087 17.4553 36.58 16.502 36.58 15.27C36.58 14.1407 36.2867 13.268 35.7 12.652C35.128 12.036 34.1747 11.728 32.84 11.728H31.608ZM42.9 17.162C42.5773 16.8687 42.1667 16.722 41.668 16.722C41.1547 16.722 40.7367 16.8687 40.414 17.162C40.106 17.4553 39.952 17.844 39.952 18.328C39.952 18.812 40.106 19.2007 40.414 19.494C40.7367 19.7873 41.1547 19.934 41.668 19.934C42.1667 19.934 42.5773 19.7873 42.9 19.494C43.2227 19.2007 43.384 18.812 43.384 18.328C43.384 17.844 43.2227 17.4553 42.9 17.162Z"
                  />
                </svg>
                <span>BeautyFluent</span>
              </div>
            </router-link>
          </li>
          <li>
            <router-link :to="'/brand/clean?cpcmain=true'">
              <!-- <img id="brandCleanPreCheck" class="retailer-icon-style" />
              {{ $t("Components.Brands.Header.preCheck") }} -->
              <div class="svg-menu-icon">
                <svg
                  width="54"
                  height="24"
                  viewBox="0 0 54 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M37 11.08V12C36.9988 14.1564 36.3005 16.2547 35.0093 17.9818C33.7182 19.709 31.9033 20.9725 29.8354 21.5839C27.7674 22.1953 25.5573 22.1219 23.5345 21.3746C21.5117 20.6273 19.7847 19.2461 18.611 17.4371C17.4373 15.628 16.8798 13.4881 17.0217 11.3363C17.1636 9.18455 17.9972 7.13631 19.3983 5.49706C20.7994 3.85781 22.6928 2.71537 24.7962 2.24013C26.8996 1.7649 29.1003 1.98232 31.07 2.85999"
                    stroke="#202020"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M37 4L27 14.01L24 11.01"
                    stroke="#202020"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>{{ $t("Components.Brands.Header.preCheck") }}</span>
              </div>
            </router-link>
          </li>
          <li>
            <router-link to="/brand/messaging?tab=received">
              <a-badge
                v-if="unReadMessage > 0"
                :count="unReadMessage"
                :overflow-count="99"
                style="font-size:24px;"
              >
                <a-icon type="inbox" />
              </a-badge>
              <a-icon v-else class="retailer-icon-style" type="inbox" />
              <span
                :style="
                  unReadMessage > 0 ? 'display:block;margin-top:-4px;' : ''
                "
                >Inbox</span
              >
            </router-link>
          </li>
          <li class="dropdown" style="width: 54px">
            <a href="#">
              <img
                v-if="brand.logoAsset.url"
                class="dropdown-icon-container"
                :src="brand.logoAsset.url"
              />
              <img
                v-if="!brand.logoAsset.url"
                class="dropdown-icon-container"
                :src="require('@/assets/img/default-logo-image.png')"
              />
            </a>
            <div class="profile-menu">
              <router-link to="/brand/profile">
                <a-icon class="menu-icon-style" type="user" />
                {{ $t("Components.Brands.Header.profile") }}
              </router-link>
              <router-link :to="{ name: 'brandMyAccount' }">
                <a-icon class="menu-icon-style" type="setting" />
                {{ $t("Components.Brands.Header.settings") }}
              </router-link>
              <a @click.prevent="signOut()">
                <img
                  src="~@/assets/img/retailer-brand-profile/signout.svg"
                  alt=""
                />
                <span style="color:#FF6132">
                  {{ $t("Components.Brands.Header.signOut") }}
                </span>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// import SvgTraining from "@/assets/img/icons/training.svg";
import firebase from "@/services/firebase-service";
import RetailerQuickSearch from "@/components/brands/retailers/RetailerQuickSearch";

export default {
  components: {
    RetailerQuickSearch,
  },
  data() {
    return {
      isShowSearch: true,
      topMenu: false,
      isLegacy: false,
      accountLinks: [
        { name: "Profile", path: "/brand/profile" },
        { name: "Catalog", path: "/brand/products" },
        { name: "Orders", path: "/brand/orders" },
        { name: "Settings", path: "/brand/settings" },
      ],
      showPlan: false,
      retailerAtoZ: false,
      retailerSearch: false,
      memberRemoved: false,
      showSearchDropdown: false,
    };
  },
  computed: {
    brand() {
      return this.$store.getters["brand/brand"];
    },
    unReadMessage() {
      return this.$store.getters["adminMessage/unReadMessageCount"];
    },
    isBrandPremium() {
      return (
        this.brand &&
        this.brand.subscriptions &&
        this.brand.subscriptions[0].type.id == "premium"
      );
    },
    isBrandExpired() {
      if (
        this.brand &&
        this.brand.subscriptions &&
        this.brand.subscriptions.length !== 0
      ) {
        return (
          (this.brand.subscriptions[0].type.id == "basic" ||
            this.brand.subscriptions[0].type.id == "premium" ||
            this.brand.subscriptions[0].type.id == "subscriber") &&
          this.checkTrialIsEnd()
        );
      } else {
        return false;
      }
    },
    isEmailVerified() {
      return this.$store.getters["user/isEmailVerified"];
    },
    isBrandApproved() {
      return (
        this.brand.status &&
        this.brand.status.id === "approved" &&
        this.isEmailVerified
      );
    },
    role() {
      return this.$store.getters["user/role"];
    },
    userEmail() {
      return this.$store.getters["user/email"];
    },
    userId() {
      return this.$store.getters["user/id"];
    },
    isWorkspacePages() {
      return [
        "brandProfile",
        "brandCatalog",
        "brandOrders",
        "brandAnalytics",
        "brandSettings",
        "brandOrder",
        "brandProduct",
        "terms",
        "about",
        "privacyPolicy",
        "purchaseOrderTerms",
        "copyrightDisputePolicy",
      ].includes(this.$route.name);
    },
    monthAgo() {
      const today = new Date();
      const monthAgoDate = new Date(
        today.getFullYear(),
        today.getMonth() - 1,
        today.getDate()
      );

      return monthAgoDate.toISOString().split("T")[0];
    },
  },

  watch: {
    async brand() {
      this.isMemberRemoved();
    },
  },
  mounted() {
    this.$watch(
      "$refs.retailerQuickSearch.showDropdown",
      (new_value) => (this.showSearchDropdown = new_value)
    );
  },
  async created() {
    // if (await this.isLegacyUser()) {
    //   this.isLegacy = true
    // }
    this.isLegacy = false;
    this.isMemberRemoved();
    this.$store.dispatch("adminMessage/getUnReadMessage");
  },
  methods: {
    mySearch() {
      this.$router.push({
        name: "Search",
      });
    },
    async sha256(email) {
      const msgBuffer = new TextEncoder("utf-8").encode(email);
      const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray
        .map((b) => ("00" + b.toString(16)).slice(-2))
        .join("");
      return hashHex;
    },
    async isLegacyUser() {
      return (
        await firebase
          .database()
          .ref("legacy/users/" + (await this.sha256(this.userEmail)))
          .once("value", (snapshot) => {
            return snapshot.val();
          })
      ).toJSON();
    },
    async isMemberRemoved() {
      for (var a in this.brand.members) {
        if (
          this.brand.members[a] &&
          this.brand.members[a].user &&
          this.brand.members[a].user.id &&
          this.brand.members[a].user.id == this.userId
        ) {
          if (
            this.brand.members[a] &&
            this.brand.members[a].membershipStatus &&
            this.brand.members[a].membershipStatus.id &&
            this.brand.members[a].membershipStatus.id == "removed"
          ) {
            this.memberRemoved = true;
          }
        }
      }
    },
    signOut() {
      this.$store.dispatch("user/signOut");
      this.$router.push("/login");
    },
    hideTopMenu() {
      this.topMenu = false;
    },
    toggle() {
      this.topMenu = !this.topMenu;
    },
    hide() {
      this.showPlan = false;
    },
    checkTrialIsEnd() {
      let time;
      const brandInfo = this.brand;
      if (
        brandInfo &&
        brandInfo.subscriptions &&
        brandInfo.subscriptions.length !== 0
      ) {
        const myDate = new Date(new Date().getTime() + 8 * 60 * 60 * 1000);
        const list = myDate
          .toJSON()
          .split("T")
          .slice(0, 10);
        time = list[0];
        const timeValue = this.getDaysBetween(
          time,
          brandInfo.subscriptions[0].endDate
        );
        return timeValue === 0;
      } else {
        return false;
      }
    },
    getDaysBetween(date1, date2) {
      const startDate = Date.parse(date1);
      const endDate = Date.parse(date2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate === endDate) {
        return 1;
      }
      return Math.floor((endDate - startDate) / (1 * 24 * 60 * 60 * 1000));
    },
  },
};
</script>

<style scoped>
/* Font Configuration */

@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@600&display=swap");
@font-face {
  font-family: "ProximaNova-Regular";
  src: url(~@/assets/fonts/ProximaNova-Regular.ttf) format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SF-Pro-Display-Regular";
  src: url(~@/assets/fonts/SFProDisplay-Regular.ttf) format("truetype");
  font-weight: normal;
  font-style: normal;
}

/* Colors */

:root {
  --Gray-2: #fafafa;
  --Gray-3: #f5f5f5;
  --Gray-4: #e8e8e8;
  --Gray-5: #d9d9d9;
  --Gray-7: #8c8c8c;
  --Gray-8: #595959;
  --Gray-10: #000000;
  --Landing_Brand_Orange: #ff6132;
  --Landing_Green: #4a8a5d;
}

* {
  margin: 0;
  box-sizing: border-box;
}

body {
  font-family: "ProximaNova-Regular";
}

.wrapper {
  width: 100%;
  margin: 0 auto;
}

/* Navigation Style */

.quick-search {
  /*margin-left: 5%;*/
  margin-right: 1%;
}

.column {
  padding: 3px 0px 3px 0px;
}

.desktop-nav {
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1;
  font-family: "ProximaNova-Regular";
}

.desktop-nav .nav-container {
  position: relative;
  display: -webkit-flex;
  justify-content: space-between;
  max-width: 1197px;
  /*min-width: 954px;*/
  margin: auto;
  /*box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 0;*/
}

.desktop-nav .logo {
  margin-top: 13px;
  margin-bottom: 13px;
  margin-left: 126px;
}

.desktop-nav .menu-items {
  margin-top: 20px;
  margin-bottom: 5px;
  margin-right: 106px;
  display: -webkit-flex;
  list-style: none;
}

.desktop-nav .menu-items li {
  margin: 0 12px;
}

.desktop-nav .menu-items li a {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 27px;
  text-decoration: none;
  /* color: var(--Gray-7); */
}

.desktop-nav .menu-items li img {
  display: block;
  margin: auto;
}

.inventory {
  padding: 3px 1px;
}

.catalog {
  padding: 1px 3px;
}

.payments {
  padding: 1px 1px;
}

.cpcheck {
  padding-top: 1px;
  padding-bottom: 2px;
}

.desktop-nav .menu-items .dropdown .dropdown-icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid #8c8c8c;
  width: 36px;
  height: 36px;
  margin-top: 1px;
  margin-bottom: 0px;
}

/* Begin Dropdown */

.desktop-nav .menu-items li .profile-menu {
  display: none;
  position: absolute;
  margin-top: 48px;
  min-width: 99px;
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  margin-left: -28px;
  z-index: 5;
}

.desktop-nav .menu-items li .profile-menu a {
  display: block;
  padding: 4px;
  padding-left: 36px;
  font-family: "ProximaNova-Regular" !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: var(--Gray-8);
}

.desktop-nav .menu-items li .profile-menu a img {
  display: block;
  position: absolute;
  margin-left: -24px;
  margin-top: 2px;
}

.desktop-nav .menu-items li .profile-menu a:hover {
  background-color: var(--Gray-4);
}

.desktop-nav .menu-items .dropdown:hover .profile-menu {
  display: block;
}
.router-link-active {
  color: #4a8a5d !important;
}
.retailer-icon-style {
  display: block;
  font-size: 24px;
}

.retailer-icon-style-new {
  display: block;
  font-size: 24px;
}

.router-link-active.retailer-icon-style-new {
}
.retailer-header-style {
  /*margin-bottom: 10px;*/
  width: 24px;
  height: 24px;
}
#brandCleanPreCheck {
  content: url("~@/assets/img/clean-pre-check/clean_nav_gray.svg");
}
.router-link-active > #brandCleanPreCheck {
  content: url("~@/assets/img/clean-pre-check/clean_nav_green.svg");
}
#retailerHeaderIcon {
  content: url("~@/assets/img/R_header_icon.svg");
}
.router-link-active > #retailerHeaderIcon {
  content: url("~@/assets/img/R_header_icon_active.svg");
}
.menu-icon-style {
  display: block;
  position: absolute;
  margin-left: -24px;
  margin-top: 2px;
  font-size: 14px;
}
</style>
<style lang="scss">
.nav-container .menu-items li .ant-badge .ant-badge-multiple-words {
  padding: 0 2px;
}
.nav-container .menu-items li .ant-badge .ant-badge-count {
  background: #ff6132;
  height: 18px;
  min-width: 18px;
  padding: 0 2px;
  line-height: 18px;
}

.menu-items {
  a {
    color: rgb(74, 74, 74);
    svg {
      color: rgb(74, 74, 74);
    }

    .fill {
      svg {
        path {
          fill: rgb(74, 74, 74);
        }
      }
    }
    :not(.fill) {
      svg {
        path {
          stroke: rgb(74, 74, 74);
        }
      }
    }

    .svg-menu-icon {
      display: flex;
      flex-direction: column;
      align-items: center;

      &.fill {
        svg {
          path {
            fill: rgb(74, 74, 74);
          }
        }
      }
    }

    &.router-link-active {
      color: rgb(74, 138, 93);

      svg {
        color: rgb(74, 138, 93);
        path {
          //stroke: rgb(74, 138, 93);
        }
      }

      .fill {
        svg {
          path {
            fill: rgb(74, 138, 93) !important;
          }
        }
      }

      :not(.fill) {
        svg {
          path {
            stroke: rgb(74, 138, 93);
          }
        }
      }
    }

    &[disabled="disabled"] {
      color: rgba(0, 0, 0, 0.25) !important;
      svg {
        color: rgba(0, 0, 0, 0.25) !important;
        path {
          fill: rgba(0, 0, 0, 0.25) !important;
          stroke: rgba(0, 0, 0, 0.25) !important;
        }
      }
    }
  }
}
</style>
